<template>
  <div class="editQrcode">
    <Navbar title="编辑二维码"/>
    <div class="clearfix topBg header">
      <div class="item">
        <span>护理站名称</span>
        <div class="input">
          <input type="text" placeholder="请输入护理站名称" v-model="roomName"
                 @input="changeInputVal($event,/[^a-z0-9A-Z\u4e00-\u9fa5]+/g,'roomName',0,12)"/>
        </div>
      </div>
      <div class="item">
        <span>床位号</span>
        <div class="input">
          <input type="text" placeholder="请输入床位号" v-model="bedName"
                 @input="changeInputVal($event,/[^a-z0-9A-Z\u4e00-\u9fa5]+/g,'bedName',0,15)"/>
        </div>
      </div>
    </div>
    <div class="save">
      <button class="themeColor" @click="editInfo">保存</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Toast} from "vant";

export default {
  name: "editQrCode",
  components: {Navbar},
  data() {
    return {
      uuid: "",
      roomName: null,
      bedName: null
    }
  },
  created() {
    this.uuid = this.$route.query.uuid;
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    editInfo() {
      if (!this.bedName) {
        return Toast('请输入床位号');
      }
      if (!this.roomName) {
        return Toast('请输入护理站名称');
      }

      let data = {
        uuid: this.uuid,
        roomName: this.roomName,
        bedName: this.bedName
      }
      this.$post('address/editInfo', data).then(result => {
        if (result.status === 200) {
          this.$router.go(-1);
          Toast('修改成功');
        } else {
          return Toast(result.msg);
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.editQrcode {
  font-size: 15px;

  .header {
    .item:first-child {
      margin-top: 35px;
    }

    .item:nth-child(2) {
      margin-top: 25px;
    }

    .item {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #042151;

      span {
        font-size: 18px;
      }

      .input {
        width: 100%;
        margin-top: 15px;
        display: flex;
        justify-content: center;
        padding: 0 15px;
        box-sizing: border-box;

        input {
          width: 100%;
          height: 55px;
          background: #FFFFFF;
          border-radius: 8px;
          border: none;
          text-align: center;
          font-size: 15px;
        }
      }
    }
  }

  .save {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 93px;

    button {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>